// extracted by mini-css-extract-plugin
module.exports = {"container":"foundInfo_container__3orRp","header":"foundInfo_header__2o-nf","title":"foundInfo_title__2IwyV","btn":"foundInfo_btn__3yo8w","block":"foundInfo_block__1OQO-"};